import type { CartLine, ParkedBasket } from "./types";

const isLine = (value: unknown): value is CartLine => {
  if (!value || typeof value !== "object") return false;
  const line = value as Partial<CartLine>;
  return typeof line.id === "string" && line.id.length > 0 && line.id.length <= 100 &&
    typeof line.name === "string" && line.name.length > 0 && line.name.length <= 200 &&
    Number.isFinite(line.price) && Number(line.price) >= 0 &&
    Number.isSafeInteger(line.quantity) && Number(line.quantity) > 0 && Number(line.quantity) <= 999;
};

export function parseParkedBaskets(raw: string | null): ParkedBasket[] {
  try {
    const value = JSON.parse(raw ?? "[]") as unknown;
    if (!Array.isArray(value)) return [];
    return value.slice(0, 100).filter((item): item is ParkedBasket => {
      if (!item || typeof item !== "object") return false;
      const basket = item as Partial<ParkedBasket>;
      return typeof basket.id === "string" && basket.id.length <= 100 &&
        typeof basket.name === "string" && basket.name.length > 0 && basket.name.length <= 40 &&
        typeof basket.createdAt === "string" && typeof basket.updatedAt === "string" &&
        (basket.paymentState === undefined || basket.paymentState === "unpaid") &&
        Array.isArray(basket.lines) && basket.lines.length > 0 && basket.lines.length <= 200 && basket.lines.every(isLine);
    });
  } catch {
    return [];
  }
}

export function mergeBasketLines(current: CartLine[], incoming: CartLine[]): CartLine[] {
  const merged = current.map((line) => ({ ...line }));
  for (const line of incoming) {
    const existing = merged.find((candidate) => candidate.id === line.id);
    if (existing) existing.quantity += line.quantity;
    else merged.push({ ...line });
  }
  return merged;
}

export const basketItemCount = (basket: ParkedBasket) =>
  basket.lines.reduce((total, line) => total + line.quantity, 0);

export const basketTotal = (basket: ParkedBasket) =>
  basket.lines.reduce((total, line) => total + line.price * line.quantity, 0);
